<template>
  <v-container fluid>
    <v-card class="d-flex-column justify-space-between ma-0" id="part-refs">
<!--      <v-breadcrumbs :items="quote.versions">
         <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :href="item"
      >
        {{ item.toUpperCase() }}
      </v-breadcrumbs-item>
      </template>
      </v-breadcrumbs>
-->
    <v-card-title> Στοιχεία Ανταλλακτικού </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          :valid="valid"
        >
        <v-row>
          <v-col cols=2 sm=2 md=2>
          <v-text-field
          label="Αρ. Επισκευής"
          v-model="part.Id"
          prepend-icon="mdi-counter"
            >
          </v-text-field>
          </v-col>
            <v-col cols=12 sm=4 md=3>
          <v-text-field
            v-model="part.Description"
            readonly
            label="Όχημα"
            >
             <template v-slot:append>
              <v-btn icon @click="vehicleDetails"><v-icon>mdi-information</v-icon></v-btn>
            </template>
          </v-text-field>
          </v-col>

        </v-row>
         <v-row>
          <v-col cols=12 md=6>
          <v-text-field
            v-model="part.FmSku"
            prepend-icon="mdi-counter"
            readonly
            label="Πελάτης"
            >
            <template v-slot:append>
              <v-btn icon @click="accountPage"><v-icon>mdi-information</v-icon></v-btn>
            </template>
            </v-text-field>

            </v-col>
        </v-row>
          <v-row>
          <v-col cols=12 md=6>
          <v-textarea
            v-model="part.Notes"
            prepend-icon="mdi-notebook"
            rows="1"
            :auto-grow=true
            label="Σημειώσεις"
            hint="Αριθμός πλαισίου, όχημα, κλπ"
            >
         </v-textarea>
          </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
      <v-speed-dial
      v-model="fab"
      top
      right
      direction="left"
      absolute
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue darken-2"
          dark
          fab
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="updateNotes">
              <v-icon dark>mdi-content-save</v-icon>
            </v-btn>
             <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getPDF"
              >
              <v-icon dark>mdi-file-pdf-box</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="invoice">
              <v-icon dark>mdi-printer-pos</v-icon>
            </v-btn>
        </v-speed-dial>
      </v-card-actions>
    </v-card>

    <v-card class="mx-auto mt-10" id="item-list" >
      <v-card-title>Αντιστοιχίες</v-card-title>
      <v-card-text>
      <v-data-table
        :headers="showHeaders"
        :items="partReferences"
        item-key="itemId"
        :search="search"
        :item-class="rowClass"
        class="elevation-0"
        height="600px"
        mobile-breakpoint=800
        dense
        fixed-header>

        <v-divider inset></v-divider>
        <template v-slot:top>
          <v-toolbar flat height="120px" color="white">
            <div class="d-flex w-200">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" dense outlined single-line hide-details></v-text-field>
            <v-dialog
                v-model="dialog"
                persistent
                max-width="600px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon dark>mdi-plus</v-icon>Αντιστοιχία
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="part">
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm=8
                          md=8
                          xs=12
                        >
                          <v-combobox
                            label="Κατασκευαστής"
                            :rules="[rules.required]"
                            :items="manufacturers"
                            v-model="editedItem.Manufacturer"
                            dense
                            ></v-combobox>
                        </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-text-field
                            label="Κωδικός*"
                            :rules="[rules.required]"
                            v-model="editedItem.Sku"
                            dense
                            required
                            ></v-text-field>

                      </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-switch
                            label="Γνήσιο*"
                            :rules="[rules.required]"
                            v-model="editedItem.OEM"
                            dense
                            required
                            ></v-switch>

                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
              <v-spacer/>
            </v-toolbar>
          </template>

        <template v-slot:item.index="{ item }">
          <span>{{partReferences.indexOf(item)+1}}</span>
        </template>
        <template v-slot:item.OEM="{ item }">
          <span v-if="item.OEM">Ναι</span>
          <span v-else>Όχι</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div>
            <v-icon class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon class="mr-3" @click="copyItem(item)">
              mdi-content-copy
            </v-icon>
            <v-icon @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </div>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
//const _ = require("lodash");


// import filter from "lodash/filter";

export default {
  props: {
    //partReferences: []
  },
  computed: {
    pdfPath () {
        return `${this.$api.defaults.baseURL}/parts/${this.part.Id}/card/`;
    },
    showHeaders() {
        if (this.$vuetify.breakpoint.smAndDown) {
            return this.headers.filter(h => !(["vat", "Status", "value", "TechId"]).includes(h.value));
        } else {
            return this.headers;
        }
    },
    manufacturers() {
      return this.$manufacturers.map(e=>e.title);
    },
    formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },

  },

  data () {
    return {
    menu: false,
    fab: false,
    valid: true,
    dialog: false,
    part: {},
    technicians: {},
    rules: {
        required: value => !!value || 'Required.',
    },
    search: '',
    headers: [
      {
        text: 'Α/Α',
        value: 'itemId',
        sortable: true,
        width: '2%'
      },
      {
        text: 'Κατασκευαστής',
        value: 'Manufacturer',
        align: 'center',
        sortable: true,
        width: '25%'
      },
      {
        text: 'Κωδικός Κατασκευαστή',
        value: 'Sku',
        sortable: false,
        align: 'start',
        width: '35%'
      },
      {
        text: 'Γνήσιο',
        value: 'OEM',
        sortable: true,
        width: '25%'
      },
      { text: 'Actions', value: 'actions', sortable: false , width: "150px"},
    ],
    partReferences: [],
    editedIndex: -1,
    editedItem: {
      itemId: 0,
      Manufacturer: '',
      Sku: 1,
      Oem: false,
    },
    defaultItem: {
      itemId: 0,
      Manufacturer: '',
      Sku: 1,
      Oem: false,
    }
    }
  },
  async created () {
      this.initialize();
  },

  methods: {
   accountPage() {
        let path = "customer-info"
        let params = {"id": this.part.Vehicle.Owner.Id}
        if (this.part.Vehicle.Owner.Cid.startsWith("G")) {
              path = 'book-info';
        }

        this.$router.push({"name": path, "params": params});
    },
    vehicleDetails() {
        let path = "Vehicle"
        let params = {"vehicle": this.part.VehId}
        this.$router.push({"name": path, "params": params});
    },
    sumTotals(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b.Price*b.Qty || 0), 0);
    },
    async updateNotes () {
        await this.$api.patch("/inventory/parts/info/"+this.$route.params.id, {Notes: this.part.Notes});
    },
    async invoice () {
        const response = await this.$api.patch("/parts/invoice/"+this.$route.params.partId);
        if (response.status == 202) {
              this.part = response.data;
              this.partReferences = [];
              let j = 1;
              for (var value of this.part.References) {
                value.itemId = j;
                this.partReferences.push(value);
                j +=1;
              }
        }
    },
    async getPDF () {
        const response = await this.$api.get(`/parts/${this.part.Id}/card`);
        window.open(`${this.$api.defaults.baseURL}/parts/card/${response.data}`, '_blank');
    },
    rowClass (item) {
      return this.partReferences.indexOf(item) %2 ? 'blue-grey lighten-5' : 'white darken-2';
    },
    async initialize () {
      const response = await this.$api.get("/inventory/parts/info/" + this.$route.params.id, {cache: {maxAge: 30*1000}});
      this.part = response.data;
      let j = 1;
      for (var value of this.part.References) {
        value.itemId = j;
        this.partReferences.push(value);
        j +=1;
      }

      // console.log(this.quote);

    },
    copyItem (item) {
      const addObj = Object.assign({}, item);
      addObj.itemId = this.partReferences.length + 1;
      this.partReferences.unshift(addObj);
    },
    editItem (item) {
      this.editedIndex = this.partReferences.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem (item) {
      const index = this.partReferences.indexOf(item);
      if (confirm('Are you sure you want to delete this item?')) {
              this.partReferences.splice(index, 1);
          }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300)
    },
    addNew() {
       const addObj = Object.assign({}, this.defaultItem);
       addObj.itemId = this.partReferences.length + 1;
       this.partReferences.unshift(addObj);
       this.editItem(addObj);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.partReferences[this.editedIndex], this.editedItem);
        this.patchPartItem();
      } else{
        this.partReferences.push(this.editedItem);
        this.patchPartItem();
      }
      this.close()
    },
    async patchPartItem() {

      const response = await this.$api.patch("/inventory/parts/info/"+this.$route.params.id, {References: this.partReferences})
      console.log(response);

    },
  },
  }
</script>

<style>
.row-odd {
  background-color: orange;
}
.row-even {
  background-color: "red";
}
</style>
